import React from 'react';
import { useTranslation } from 'react-i18next';
import { MdCheckCircle } from 'react-icons/md';
import TipsWaiterTeamPhoto from './tipsWaiterTeamPhoto';

const TipsWaiterSelection = ({
  employees,
  selectedEmployee,
  onSelectEmployee,
  onSelectTeam,
  preventSelectAllTeam,
}) => {
  const { t } = useTranslation();

  if (!employees || employees.length === 0) {
    return null;
  }

  const renderEmployee = (employee, ind, isTeam) => {
    const isSelected =
      (!selectedEmployee && isTeam) || (employee && selectedEmployee === employee.id);

    return (
      <div
        key={isTeam ? 'team' : employee.id}
        className={`w-full ${ind % 2 === 1 ? 'flex justify-end sm:block' : ''}`}
      >
        <div
          className="min-w-[5rem] min-h-[5rem] max-w-[12rem] max-h-[12rem] w-full h-full
            rounded-lg relative overflow-hidden cursor-pointer"
          onClick={() => {
            if (isTeam) {
              onSelectTeam();
            } else {
              onSelectEmployee(employee);
            }
          }}
        >
          {!isTeam && employee.image ? (
            <img className="w-full h-full" src={employee.image} alt="" />
          ) : (
            <div
              className={`bg-lightGrayBg w-full h-full
              ${isTeam ? 'flex items-center justify-center' : ''}`}
            >
              {isTeam && (
                <div className="px-2 -mt-5">
                  <TipsWaiterTeamPhoto employees={employees} />
                </div>
              )}
            </div>
          )}
          <p
            className={`absolute bottom-3 left-2 font-primaryMedium text-base leading-5 z-10 ${
              !isTeam && employee.image ? 'text-white' : 'text-bland'
            }`}
          >
            {isTeam ? t('checkout.yourRestaurantTeam') : employee.firstName}
          </p>
          {isSelected && (
            <div className="absolute top-1 right-1 z-10">
              <MdCheckCircle className="w-7 h-7 text-primary bg-white rounded-full" />
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-y-4 gap-x-4 pb-5 auto-rows-fr">
      {employees.map((employee, ind) => {
        return renderEmployee(employee, ind);
      })}
      {!preventSelectAllTeam && renderEmployee(null, employees.length, true)}
    </div>
  );
};

export default TipsWaiterSelection;
